import React from 'react'
import {
  Box,
  Heading,
  Text,
  Button,
  VStack
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import WebLayout from '../layouts/WebLayout';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <WebLayout>
      <Box
        minH="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="gray.50"
      >
        <VStack spacing={6} textAlign="center">
          <Heading size="2xl" color="gray.700">
            404 - Page Not Found
          </Heading>
          <Text fontSize="lg" color="gray.500">
            Oops! The page you're looking for doesn't exist.
          </Text>
          <Button colorScheme="blue" onClick={() => navigate("/")}>
            Go to Home
          </Button>
        </VStack>
      </Box>
    </WebLayout>
  )
}

export default PageNotFound
